import {
  GET_LOCATION,
  ADD_LOCATION,
  DELETE_LOCATION,
  MODIFY_LOCATION,
} from '../../actions';

const getInitialState = {
  get: { error: null, loaded: false, loading: false, data: [] },
  add: { error: null, loaded: false, loading: false, data: [] },
  modify: { error: null, loaded: false, loading: false },
  delete: { error: null, loaded: false, loading: false },
};

/**
 * location reducer.
 * @function location
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export const locationReducer = (state = getInitialState, action = {}) => {
  switch (action.type) {
    case `${GET_LOCATION}_PENDING`:
      return {
        ...state,
        get: {
          ...state.get,
          error: null,
          loaded: false,
          loading: true,
          data: [],
        },
      };
    case `${GET_LOCATION}_FAIL`:
      return {
        ...state,
        get: {
          ...state.get,
          error: action.error,
          loaded: false,
          loading: false,
          data: [],
        },
      };
    case `${GET_LOCATION}_SUCCESS`:
      return {
        ...state,
        get: {
          ...state.get,
          error: null,
          loaded: true,
          loading: false,
          data: action.result,
        },
      };
    case `${ADD_LOCATION}_PENDING`:
      return {
        ...state,
        add: {
          ...state.add,
          error: null,
          loaded: false,
          loading: true,
          data: [],
        },
      };
    case `${ADD_LOCATION}_FAIL`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
          loaded: false,
          loading: false,
        },
      };
    case `${ADD_LOCATION}_SUCCESS`:
      return {
        ...state,
        add: {
          ...state.add,
          error: null,
          loaded: true,
          loading: false,
          data: action.result,
        },
      };
    case `${MODIFY_LOCATION}_PENDING`:
      return {
        ...state,
        modify: {
          ...state.modify,
          error: null,
          loaded: false,
          loading: true,
          data: [],
        },
      };
    case `${MODIFY_LOCATION}_FAIL`:
      return {
        ...state,
        modify: {
          ...state.modify,
          error: action.error,
          loaded: false,
          loading: false,
          data: [],
        },
      };
    case `${MODIFY_LOCATION}_SUCCESS`:
      return {
        ...state,
        modify: {
          ...state.modify,
          error: null,
          loaded: true,
          loading: false,
          data: action.result,
        },
      };
    case `${DELETE_LOCATION}_PENDING`:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: null,
          loaded: false,
          loading: true,
          data: [],
        },
      };
    case `${DELETE_LOCATION}_FAIL`:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
          loaded: false,
          loading: false,
          data: [],
        },
      };
    case `${DELETE_LOCATION}_SUCCESS`:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: null,
          loaded: true,
          loading: false,
          data: action.result,
        },
      };
    default:
      return state;
  }
};
